module.exports = __webpack_public_path__ + "img/img_12.7cc2985b.png";